import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InspectionHome from "./components/inspection/InspectionHome";
import { InspectionRunner } from "./components/inspection/InspectionRunner";
import "./components/inspection/inspection.css";

export default function FieldInspection() {
  const { inspectionId } = useParams();
  const [access, setAccess] = useState("checking");
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/inspection/list?limit=1`, { credentials: "include" })
      .then((r) => setAccess(r.ok ? "ok" : "denied")).catch(() => setAccess("denied"));
  }, []);
  if (access !== "ok") {
    return (
      <div className="insp-page" data-testid="field-inspection-locked">
        <div className="insp-card">
          <div className="insp-card__title">{access === "checking" ? "Checking access…" : "Internal executive tool"}</div>
          {access === "denied" && <p className="insp-muted">Field Mode inspection is restricted to Moovin Forward executives. <a href="/login" data-testid="field-inspection-login-link">Sign in</a></p>}
        </div>
      </div>
    );
  }
  return (
    <div className="insp-page" data-testid="field-inspection-page">
      {inspectionId ? <InspectionRunner inspectionId={inspectionId} /> : <InspectionHome />}
    </div>
  );
}
